import type { FC } from 'react';
import { Modal } from '@interstate/components/Modal';
import { Typography } from '@interstate/components/Typography';

interface DeskingExitErrorsModalProps {
    show: boolean;
    onClose: () => void;
}

const TITLE = 'Resolve errors before continuing';
const MESSAGE =
    'This deal has missing information or errors that must be resolved before you can continue. Review and fix all items highlighted in red.';

export const DeskingExitErrorsModal: FC<DeskingExitErrorsModalProps> = ({ show, onClose }) => {
    return (
        <Modal
            size="small"
            id="desking-exit-errors-modal"
            data-testid="desking-exit-errors-modal"
            show={show}
            onHide={onClose}
            header={
                <Typography variant="h4" color="base.color.blue.700">
                    {TITLE}
                </Typography>
            }
            footer={{
                layout: 'rightAligned',
                primary: {
                    action: onClose,
                    label: 'Review Errors',
                    customIdentifiers: {
                        primaryButton: {
                            dataTestId: 'desking-exit-errors-review-btn'
                        }
                    }
                }
            }}
        >
            <Typography variant="body-md" tag="span">
                {MESSAGE}
            </Typography>
        </Modal>
    );
};
